// Google reCAPTCHA v3 helper — invisible, score-based (no checkbox).
// The site key is public by design and read from CRA env at build time.
const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "";
const SCRIPT_ID = "google-recaptcha-v3";

function loadScript() {
  return new Promise((resolve, reject) => {
    if (!SITE_KEY) return reject(new Error("recaptcha-not-configured"));
    if (window.grecaptcha && window.grecaptcha.execute) {
      window.grecaptcha.ready(() => resolve(window.grecaptcha));
      return;
    }
    let script = document.getElementById(SCRIPT_ID);
    if (!script) {
      script = document.createElement("script");
      script.id = SCRIPT_ID;
      script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(SITE_KEY)}`;
      script.async = true;
      script.defer = true;
      script.onerror = () => reject(new Error("recaptcha-load-failed"));
      document.head.appendChild(script);
    }
    script.addEventListener(
      "load",
      () => window.grecaptcha.ready(() => resolve(window.grecaptcha)),
      { once: true },
    );
    // If the script was already present but not yet ready, poll briefly.
    if (window.grecaptcha) {
      const started = Date.now();
      const tick = () => {
        if (window.grecaptcha && window.grecaptcha.execute) {
          window.grecaptcha.ready(() => resolve(window.grecaptcha));
        } else if (Date.now() - started < 8000) {
          setTimeout(tick, 150);
        }
      };
      tick();
    }
  });
}

// Returns a fresh single-use token for the given action, or "" when reCAPTCHA
// is not configured / fails to load (the backend treats an empty token as
// "captcha not enforced" only when no secret is set, otherwise rejects it —
// so this degrades gracefully in dev without blocking real users in prod).
export async function getRecaptchaToken(action = "submit") {
  if (!SITE_KEY) return "";
  try {
    const grecaptcha = await loadScript();
    return await grecaptcha.execute(SITE_KEY, { action });
  } catch (e) {
    return "";
  }
}

export const RECAPTCHA_ENABLED = Boolean(SITE_KEY);
